//ESTO DEBE SER TEMPORAL DEBEMOS BUSCAR UNA FORMA DE HACERLO CONFIGURABLE

// DONDE EL CODIGO SE DESACTIVE PERO EL APP NO REACCIONA A ESTO 

export const TEMPORARY_ACCESS_TTL_MS = 30 * 60 * 1000

const storageKey = (uid) => `ubiqua_app_temporary_access_expires:${uid}`

export function getTemporaryAccessExpiresAt(uid) {
  if (!uid) return null
  try {
    const raw = sessionStorage.getItem(storageKey(uid))
    if (!raw) return null
    const expiresAt = Number(raw)
    return Number.isFinite(expiresAt) ? expiresAt : null
  } catch {
    return null
  }
}

export function getTemporaryAccessRemainingMs(uid) {
  const expiresAt = getTemporaryAccessExpiresAt(uid)
  if (!expiresAt) return 0
  return Math.max(0, expiresAt - Date.now())
}

export function markTemporaryAccessIssued(uid) {
  if (!uid) return
  try {
    sessionStorage.setItem(storageKey(uid), String(Date.now() + TEMPORARY_ACCESS_TTL_MS))
  } catch {
    // ignore quota / private mode
  }
}

export function resolveInitialResetDialogKind(uid) {
  const expiresAt = getTemporaryAccessExpiresAt(uid)
  if (!expiresAt) return 'confirm'
  if (expiresAt > Date.now()) return 'replace'
  return 'expired'
}

export function formatTemporaryAccessRemaining(ms) {
  if (ms <= 0) return '0 s'
  if (ms < 60_000) return 'menos de 1 minuto'

  const totalSeconds = Math.ceil(ms / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  if (seconds > 0) return `${minutes} min ${seconds} s`
  return `${minutes} min`
}
